import React, { useEffect, useState } from "react";
import { PhosphorBracketsCurlyButton } from "components/Atoms/PhosphorIconButton";
import SelectMergeFieldModal from "components/MergeField/SelectMergeFieldModal/SelectMergeFieldModal";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { useValidateIsNotEmptyString } from "formvalidation/hooks";
import { Input } from "semantic-ui-react";
import { saveOrCancel } from "utilities/inputUtils";

interface Props {
  validatorKey: string
  focusOnMount?: boolean
  maxLength: number
  value: string
  onChange: (newValue: string) => void
  onEnter?: () => void
  onEsc?: () => void
  sectionName: string
  availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[]
}

const RequiredTextInputWithMergeField = (props: Props) => {
  const [isMergeFieldModalOpen, setIsMergeFieldModalOpen] = useState(false);
  const [selectionStart, setSelectionStart] = useState<number>(null);
  const [selectionEnd, setSelectionEnd] = useState<number>(null);
  const semanticRef = useSemanticUiInputRef();

  const validation = useValidateIsNotEmptyString({
    key: props.validatorKey,
    title: props.validatorKey,
    value: props.value,
    ref: semanticRef.ref,
  })

  useEffect(() => {
    if (props.focusOnMount) {
      semanticRef.ref.current.focus();
    }
  }, []);

  const onChange = (_, { value }) => {
    props.onChange(value);
  };

  const onMergeFieldSelected = (mergeField: string) => {
    const newValue = props.value.substring(0, selectionStart) + mergeField + props.value.substring(selectionEnd ?? selectionStart);
    props.onChange(newValue);
    setIsMergeFieldModalOpen(false);
    setTimeout(() => {
      const cursorPosition = selectionStart + mergeField.length;
      semanticRef.ref.current.setSelectionRange(cursorPosition, cursorPosition);
      semanticRef.ref.current.focus();
    }, 1);
  }

  const onSelectMergeFieldModalClose = () => {
    setIsMergeFieldModalOpen(false);
    semanticRef.ref.current.focus();
  }

  return <div className="flex gap">
    <Input
      ref={semanticRef.refSetter}
      value={props.value}
      onChange={onChange}
      maxLength={props.maxLength}
      error={validation.error.hasError}
      onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
      onKeyUp={e => {
        setSelectionStart(e.target.selectionStart);
        setSelectionEnd(e.target.selectionEnd);
      }}
      onClick={e => {
        setSelectionStart(e.target.selectionStart);
        setSelectionEnd(e.target.selectionEnd);
      }}
      fluid
    />
    <PhosphorBracketsCurlyButton
      layout="in-square"
      selectedStyle="green-bg"
      onClick={() => setIsMergeFieldModalOpen(true)}
      iconSize="large"
    />
    <SelectMergeFieldModal
      sectionName={props.sectionName}
      availableMergeFieldTopics={props.availableMergeFieldTopics}
      isOpen={isMergeFieldModalOpen}
      onClose={onSelectMergeFieldModalClose}
      onSelect={onMergeFieldSelected}
    />
  </div>
}

export default RequiredTextInputWithMergeField;